"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSelectedFields = void 0;
var resolveSelectedFields = function (currentReportFields, fetchedReportFields) {
    return fetchedReportFields.filter(function (field) {
        return currentReportFields.includes(field.fieldName);
    });
};
exports.resolveSelectedFields = resolveSelectedFields;
